import type { PendingBackgroundExecution } from '../store/backgroundExecutionStore';
import { resolveCopilotTargetFields } from '../store/chatInstancesStore';

export type SubagentAbortBind = {
  applicationId?: string;
  surfaceId?: string;
  targetType?: string;
};

function definedBind({
  applicationId,
  surfaceId,
  targetType,
}: SubagentAbortBind): SubagentAbortBind {
  return {
    ...(applicationId ? { applicationId } : {}),
    ...(surfaceId ? { surfaceId } : {}),
    ...(targetType ? { targetType } : {}),
  };
}

export function resolveSubagentAbortBind({
  execution,
  currentTarget,
}: {
  execution?: Pick<
    PendingBackgroundExecution,
    'applicationId' | 'surfaceId' | 'targetType'
  >;
  currentTarget: {
    targetId: string | undefined;
    targetType: string | undefined;
  };
}): SubagentAbortBind | undefined {
  if (execution && (execution.applicationId || execution.surfaceId)) {
    return definedBind(execution);
  }

  if (!currentTarget.targetId) {
    return undefined;
  }

  return definedBind(resolveCopilotTargetFields(currentTarget));
}
